import React from 'react'
import { FEATURE_UC_IN_WEBREGISTER_LINE_ITEM_DETAILS } from '../../../../constants'
import { getFeatureFromCache } from '../../../../util/feature-cache'
import { LineItemTabs as LineItemTabsUnified } from './LineItemTabs'
import { LineItemTabsLegacy } from './LineItemTabsLegacy'
import type { LineItemTabsProps } from './useLineItemTabsModel'

export type { LineItemTabsProps } from './useLineItemTabsModel'

export const LineItemTabs = (props: LineItemTabsProps) =>
  getFeatureFromCache(FEATURE_UC_IN_WEBREGISTER_LINE_ITEM_DETAILS) ? (
    <LineItemTabsUnified {...props} />
  ) : (
    <LineItemTabsLegacy {...props} onChange={props.onChange ?? (() => {})} />
  )
